import { Modal } from "antd";
import UserField from "../userFields/userField";
import Icon from "@assets/icon_config";
import "./formModal.scss";

const FieldComp = ({field , isRequired , onUserFieldChange , action , dropdownData , validateField , isModalOpen} : any) => {

  const {dataIndex  , className , type , required , errorMessage} = field;

  return (
    <div key={dataIndex} className={`user-managment__table__field ${className ? className : ''}`}>
    <div className="user-managment__table__field__label">
     {(['office_name' , 'secondary_office_name'].includes(dataIndex) ? isRequired(field) : required) &&  <span className="user-managment__table__field__required-star">*</span>}
     {field.displayName}
     </div>
    <div>
      <UserField
        type={type}
        field={field}
        onChange={onUserFieldChange}
        action={action}
        dropdownData={dropdownData.find((data: any) => data.dropdownName === field.dataIndex)?.data}
        validateField={validateField}
        isModalOpen = {isModalOpen}
        className={"user-managment__table__field__input"}
      />
      {errorMessage && (
        <div>
          <span className="errorIcon">
            <Icon name="hrainfo" />
          </span>
          <>{errorMessage}</>
        </div>
      )}
    </div>
  </div>
  )
}

const FormModal = ({setUserModalOpen , title , isModalOpen , onUserFieldChange , dropdownData , fields , action , onSave , isLoading , onCancel , formValidationError , validateField} : any) => {
  
  const isRequired = (field : any) => {
    console.log('FormModal.isRequired')
    if(field.dataIndex === 'office_name'){
      return !(fields.find((col : any) => col.dataIndex === 'secondary_office_name')?.value?.length > 0) && !['ReportUser','ReportUserAdmin'].includes(fields.find((col : any) => col.dataIndex === 'user_role')?.value);
    } else if(field.dataIndex === 'secondary_office_name'){
      return !(fields.find((col : any) => col.dataIndex === 'office_name')?.value?.length > 0) && !['ReportUser','ReportUserAdmin'].includes(fields.find((col : any) => col.dataIndex === 'user_role')?.value);
    }
  }
  
  return (
    <Modal
      wrapClassName="user-form-container"
      title={title}
      visible={isModalOpen}
      onCancel={() => {
        setUserModalOpen(false);
        onCancel(action);
      }}
      onOk={() => {
        onSave(action);
      }}
      cancelButtonProps={{ hidden: true }}
      confirmLoading={isLoading}
      okButtonProps={{ disabled: formValidationError.current }}
      zIndex={1000}
      okText="Save"
      width={"75%"}
      maskClosable ={false}
    >
    {fields?.length > 0 ?  <div className="user-managment__table custom-scroll-bar">
        <div className="user-managment__table--first">
        {fields?.slice(0,Math.ceil(fields?.length/2)).map((field: any) => (
          <FieldComp field={field} isRequired={isRequired} onUserFieldChange={onUserFieldChange} action={action} dropdownData={dropdownData} validateField={validateField} isModalOpen={isModalOpen}/>
        ))}
        </div>
        <div className="user-managment__table--second">
        {fields?.slice(Math.ceil(fields?.length/2), fields?.length).map((field: any) => (
          <FieldComp field={field} isRequired={isRequired} onUserFieldChange={onUserFieldChange} action={action} dropdownData={dropdownData} validateField={validateField} isModalOpen={isModalOpen}/>
        ))}
        </div>
      </div> :
      <div className="no-field_message">Fields/Types is missing in column configuration, please check...</div>}
    </Modal>
  );
};

export default FormModal;
